(() => {
  const SELECTOR = '[data-kh-osb]';

  const ready = (root) => {
    if (!root || root.dataset.khOsbReady === 'true') return;
    root.dataset.khOsbReady = 'true';

    const tabs = [...root.querySelectorAll('[data-kh-osb-tab]')];
    const panels = [...root.querySelectorAll('[data-kh-osb-panel]')];
    const viewAll = root.querySelector('[data-kh-osb-view-all]');

    const setViewAll = (panel) => {
      if (!viewAll) return;
      const href = panel?.dataset.khOsbViewHref || '';
      const label = panel?.dataset.khOsbViewLabel || '';
      if (!href || !label) {
        viewAll.hidden = true;
        return;
      }
      viewAll.hidden = false;
      viewAll.href = href;
      viewAll.textContent = label;
    };

    const activate = (index, { focusTab } = {}) => {
      tabs.forEach((tab, i) => {
        const on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
      });
      panels.forEach((panel, i) => {
        const on = i === index;
        panel.hidden = !on;
        panel.classList.toggle('is-active', on);
      });
      const panel = panels[index];
      setViewAll(panel);
      if (panel) bindScroller(panel);
      if (focusTab) tabs[index]?.focus();
    };

    const bindScroller = (panel) => {
      const scroller = panel.querySelector('[data-kh-osb-scroller]');
      const prev = panel.querySelector('[data-kh-osb-prev]');
      const next = panel.querySelector('[data-kh-osb-next]');
      if (!scroller) return;

      const card = scroller.querySelector('.kh-osb__card');
      const step = () => {
        const styles = getComputedStyle(scroller);
        const gap = parseFloat(styles.columnGap || styles.gap) || 18;
        return (card ? card.getBoundingClientRect().width : scroller.clientWidth * 0.8) + gap;
      };

      const syncArrows = () => {
        const max = Math.max(0, scroller.scrollWidth - scroller.clientWidth - 2);
        if (prev) prev.disabled = scroller.scrollLeft <= 2;
        if (next) next.disabled = scroller.scrollLeft >= max;
      };

      if (!scroller.dataset.khOsbBound) {
        scroller.dataset.khOsbBound = 'true';
        prev?.addEventListener('click', () => {
          scroller.scrollBy({ left: -step(), behavior: 'smooth' });
        });
        next?.addEventListener('click', () => {
          scroller.scrollBy({ left: step(), behavior: 'smooth' });
        });
        scroller.addEventListener('scroll', syncArrows, { passive: true });
        window.addEventListener('resize', syncArrows, { passive: true });
      }

      requestAnimationFrame(syncArrows);
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(index));
      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft' && event.key !== 'Home' && event.key !== 'End') return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        activate(nextIndex, { focusTab: true });
      });
    });

    const start = tabs.findIndex((tab) => tab.classList.contains('is-active'));
    activate(start >= 0 ? start : 0);
  };

  const boot = (scope = document) => {
    scope.querySelectorAll(SELECTOR).forEach(ready);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
